import { Card, CardBody, Col, Table } from "reactstrap";
import { ColoredHeadBody } from "./ColoredHeadBody";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ColoredHeadingTitle } from "../../../../Constants/Constants";
import { ColorHeadData, HeadingSubTitle } from "../../../../Data/UiKits/Typography";

const ColoredHeadings = () => {
  return (
    <Col xxl="6">
      <Card className="height-equal">
        <CommonCardHeader title={ColoredHeadingTitle} span={HeadingSubTitle}/>
        <CardBody>
          <div className="table-responsive custom-scrollbar">
            <Table className="mb-0 typography-table">
              <thead>
                <tr>
                  {ColorHeadData.map((item, index) => (
                    <th key={index} className="pt-0">{item.name}</th>
                  ))}
                </tr>
              </thead>
              <ColoredHeadBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
export default ColoredHeadings